// extracted by mini-css-extract-plugin
module.exports = {"filters":"_7a3fb80146--filters--Bw2vw"};